import { EventBase } from "features/types";
import { useAccount } from "hooks/useAccount";
import useCurrentUser from "hooks/useCurrentUser";
import { useState } from "react";
import { accountHasTdcAccountLinked } from "utils/accountUtils";
import toast from "utils/toast";

const SECONDARY_MEMBER_TDC_MESSAGE =
  "The primary account holder must first install the MLB Ballpark app on their mobile device, and provide their MLB Ballpark email address before you are able to begin making seat reservations. Please have them log into their account and complete this setup process";

const useTDCDialog = () => {
  const [TDCDialogVisible, setTDCDialogVisible] = useState(false);
  const { account } = useAccount();
  const { currentMember } = useCurrentUser();

  const withTDCCheck = (
    event: Pick<EventBase, "ticketProvider" | "providerTemplateId">,
    onProceed: () => void,
  ) => {
    if (
      event.ticketProvider === "TDC" &&
      (account?.extUserDetails?.tdcUsername === null ||
        !accountHasTdcAccountLinked(account, event.providerTemplateId))
    ) {
      if (currentMember?.type === "SECONDARY") {
        toast.info(SECONDARY_MEMBER_TDC_MESSAGE);
        return;
      }
      setTDCDialogVisible(true);
      return;
    }
    onProceed();
  };

  return { TDCDialogVisible, setTDCDialogVisible, withTDCCheck };
};

export default useTDCDialog;
